// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footerContent":"Footer_footerContent__aHfIE","copyright":"Footer_copyright__2OWH4"};